import { apiClient } from "./apiClient";

export interface ClienteB2b {
  id: number;
  nombre: string;
  fechaCreacion: string | null;
  direccion: string;
  telefono: string | null;
  celular: string | null;
  correo: string | null;
  etiquetas: string | null;
  total: number;
  totalPos: number;
  totalOrdenes: number;
  ops: number;
  opsPos: number;
  opsOrdenes: number;
  ticketPromedio: number;
  mesesActivos: number;
  promedioMensual: number;
  primeraCompra: string | null;
  ultimaCompra: string | null;
  esMayorista: boolean;
}

export interface ClientesB2bFiltros {
  q?: string | undefined;
  ingresoMin?: number | undefined;
  promedioMensualMin?: number | undefined;
  activoUltimosMeses?: number | undefined;
  mesesActivosMin?: number | undefined;
  canal?: "pos" | "ordenes" | "ambos" | undefined;
  mayorista?: "si" | "no" | undefined;
  etiquetaId?: number | undefined;
  ordenarPor?: string | undefined;
  dir?: "asc" | "desc" | undefined;
  limit?: number | undefined;
  offset?: number | undefined;
}

export interface ProductoTop {
  producto: string;
  venta: number;
  piezas: number;
}

export interface DetalleClienteB2b {
  cliente: ClienteB2b;
  serieMensual: { mes: string; canal: string; monto: number; ops: number }[];
  topProductos: ProductoTop[];
}

export interface KpisB2b {
  totalClientes: number;
  totalMayoristas: number;
  ingresoTotal: number;
  operaciones: number;
  ticketPromedioGlobal: number;
  parametros: { umbralPromedioMensual: number; mesesMinimos: number };
  topProductosGlobal: ProductoTop[];
}

export interface EtiquetaB2b {
  id: number;
  nombre: string;
  clientes: number;
}

const aParams = (filtros: ClientesB2bFiltros): Record<string, string> => {
  const params: Record<string, string> = {};
  Object.entries(filtros).forEach(([clave, valor]) => {
    if (valor !== undefined && valor !== null && valor !== "") params[clave] = String(valor);
  });
  return params;
};

class VentasB2bService {
  static async getClientes(
    filtros: ClientesB2bFiltros,
  ): Promise<{ total: number; clientes: ClienteB2b[] }> {
    const response = await apiClient.get<{ total: number; clientes: ClienteB2b[] }>("/ventas-b2b/clientes", { params: aParams(filtros) });
    return response.data;
  }

  static async getCliente(id: number): Promise<DetalleClienteB2b> {
    const response = await apiClient.get<DetalleClienteB2b>(`/ventas-b2b/clientes/${id}`);
    return response.data;
  }

  static async getKpis(filtros: ClientesB2bFiltros): Promise<KpisB2b> {
    const response = await apiClient.get<KpisB2b>("/ventas-b2b/kpis", { params: aParams(filtros) });
    return response.data;
  }

  static async getEtiquetas(): Promise<EtiquetaB2b[]> {
    const response = await apiClient.get<EtiquetaB2b[]>("/ventas-b2b/etiquetas");
    return response.data;
  }

  static async descargarExport(filtros: ClientesB2bFiltros): Promise<void> {
    const response = (await apiClient.get("/ventas-b2b/clientes/export", {
      params: aParams(filtros),
      responseType: "blob",
    })) as { data: Blob };
    const url = window.URL.createObjectURL(response.data);
    const enlace = document.createElement("a");
    enlace.href = url;
    enlace.download = "clientes_b2b.csv";
    document.body.appendChild(enlace);
    enlace.click();
    document.body.removeChild(enlace);
    window.URL.revokeObjectURL(url);
  }

  static formatCurrency(valor: number): string {
    if (!Number.isFinite(valor)) return "$0";
    return new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(valor);
  }
}

export default VentasB2bService;
